console.log("COOKIES.JS")

document.addEventListener('DOMContentLoaded', function () {
    window.Shopify.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        error => {
            if (error) {
                // Rescue error
            }
            // If error is false, the API has loaded and ready to use!
        },
    )

    console.log("Features loaded")


    window.addEventListener("cf_consent", function (event) {

        console.log(".functional", event.detail.functional)
        console.log(".advertising", event.detail.advertising)
        window.Shopify.customerPrivacy.setTrackingConsent(
            {
                "analytics": event.detail.functional,
                "marketing": event.detail.advertising,
            },
            () => console.log("Consent captured")
        );
    });
})
